import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler} from 'ionic-angular';
import { Angulartics2Module } from 'angulartics2';

//Export
export {PageRef} from './page-ref';
export { Navigation } from './navigation';


@NgModule({
    imports: [
        IonicModule,
        Angulartics2Module.forChild()
    ],
    declarations: [
    ],
    exports: [
    ],
    bootstrap: [],
    entryComponents: [
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}]
})
export class CoreModule{}


// WEBPACK FOOTER //
// ./src/core/core.module.ts